var _path, _g, _path2, _mask, _g2, _g3, _g4, _g5, _g6, _g7, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#93C9FF",
    d: "M0 0H170V170H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 103C10.6112 103 3 95.3888 3 86C3 76.6112 10.6112 69 20 69C29.3888 69 37 76.6112 37 86C37 95.3888 29.3888 103 20 103Z",
    fill: "#2B63D0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svga",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 69,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 103C10.6112 103 3 95.3888 3 86C3 76.6112 10.6112 69 20 69C29.3888 69 37 76.6112 37 86C37 95.3888 29.3888 103 20 103Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svga)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 73.25L20.8086 81.3457L18.1405 85.5131L3 93.0833V98.75L20.4668 90.0166L21.9533 86.44L37 78.9167V73.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 76.7917L19.9399 85.3217L19.9411 86.7378L37 78.2084V76.7917Z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1589 84.7122L3.00001 93.7917V95.2083L21.1073 86.1547L21.1589 84.7122Z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 73.9583L21.5617 83.2391L22.4884 85.8275L37 93.0833V98.0416L22.0071 90.5452L20.9839 87.9086L3 78.9166V73.9583Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4884 86.9525L37.0001 95.2083V97.3333L20.303 88.9848 20.4884 86.9525zM3 74.6667L21.7033 84.0183 20 84.5834 3 76.0834 3 74.6667z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9583 69H15.0417V80.6875H3V91.3125H15.0417V103H24.9583V91.3125H37V80.6875H24.9583V69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8333 69H17.1667V82.8125H3V89.1875H17.1667V103H22.8333V89.1875H37V82.8125H22.8333V69Z",
    fill: "#E62048"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 116C101.569 116 115 102.569 115 86C115 69.4315 101.569 56 85 56C68.4315 56 55 69.4315 55 86C55 102.569 68.4315 116 85 116Z",
    fill: "#E62048"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgb",
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 56,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 116C101.569 116 115 102.569 115 86C115 69.4315 101.569 56 85 56C68.4315 56 55 69.4315 55 86C55 102.569 68.4315 116 85 116Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB02",
    d: "M55 97.25H115V119.75H55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M55 52.25H115V74.75H55z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 103C159.389 103 167 95.3888 167 86C167 76.6112 159.389 69 150 69C140.611 69 133 76.6112 133 86C133 95.3888 140.611 103 150 103Z",
    fill: "#2B63D0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgc",
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 69,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 103C159.389 103 167 95.3888 167 86C167 76.6112 159.389 69 150 69C140.611 69 133 76.6112 133 86C133 95.3888 140.611 103 150 103Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M143.625 69H156.375V103H143.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E62048",
    d: "M156.375 69H169.125V103H156.375z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 157C60.3888 157 68 149.389 68 140C68 130.611 60.3888 123 51 123C41.6112 123 34 130.611 34 140C34 149.389 41.6112 157 51 157Z",
    fill: "#2B63D0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgd",
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 123,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 157C60.3888 157 68 149.389 68 140C68 130.611 60.3888 123 51 123C41.6112 123 34 130.611 34 140C34 149.389 41.6112 157 51 157Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgd)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7291 136.281L56.6882 136.828 56.887 135.669 56.0449 134.849 57.2087 134.68 57.7291 133.625 58.2495 134.68 59.4132 134.849 58.5712 135.669 58.77 136.828 57.7291 136.281zM52.7708 143.365L51.73 143.912 51.9288 142.753 51.0867 141.932 52.2504 141.763 52.7708 140.708 53.2913 141.763 54.455 141.932 53.6129 142.753 53.8117 143.912 52.7708 143.365zM58.4375 145.844L57.813 146.172 57.9323 145.477 57.427 144.984 58.1252 144.883 58.4375 144.25 58.7498 144.883 59.448 144.984 58.9427 145.477 59.062 146.172 58.4375 145.844zM44.9792 151.51L43.5219 152.277 43.8003 150.654 42.6213 149.505 44.2506 149.268 44.9792 147.792 45.7078 149.268 47.337 149.505 46.1581 150.654 46.4364 152.277 44.9792 151.51zM57.7291 152.573L56.6882 153.12 56.887 151.961 56.0449 151.14 57.2087 150.971 57.7291 149.917 58.2495 150.971 59.4132 151.14 58.5712 151.961 58.77 153.12 57.7291 152.573zM62.6876 141.948L61.6467 142.495 61.8455 141.336 61.0034 140.515 62.1671 140.346 62.6876 139.292 63.208 140.346 64.3717 140.515 63.5297 141.336 63.7284 142.495 62.6876 141.948z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 140C44.6581 140 51 140 51 140C51 140 51 134.036 51 131.5C51 129.434 51 123 51 123C51 123 45.1279 123 42.5 123C40.5368 123 34 123 34 123C34 123 34 128.769 34 131.5C34 133.73 34 140 34 140C34 140 40.0356 140 42.5 140Z",
    fill: "#2B63D0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svge",
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 123,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 140C44.6581 140 51 140 51 140C51 140 51 134.036 51 131.5C51 129.434 51 123 51 123C51 123 45.1279 123 42.5 123C40.5368 123 34 123 34 123C34 123 34 128.769 34 131.5C34 133.73 34 140 34 140C34 140 40.0356 140 42.5 140Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svge)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 123H36.125L51 137.875V140H48.875L34 125.125V123Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 123L42.5 131.5V132.917L34 124.417V123zM42.5 130.083L51 138.583V140L42.5 131.5V130.083z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 123H48.875L34 137.875V140H36.125L51 125.125V123Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9167 131.5L35.4167 140H34.0001L42.5001 131.5H43.9167zM51 123L42.5 131.5H41.0833L49.5833 123H51z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0208 123H44.9792V128.844H51V134.156H44.9792V140H40.0208V134.156H34V128.844H40.0208V123Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0833 123H43.9167V129.906H51V133.094H43.9167V140H41.0833V133.094H34V129.906H41.0833V123Z",
    fill: "#E62048"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 157C128.389 157 136 149.389 136 140C136 130.611 128.389 123 119 123C109.611 123 102 130.611 102 140C102 149.389 109.611 157 119 157Z",
    fill: "#FFCB02"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgf",
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 123,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 157C128.389 157 136 149.389 136 140C136 130.611 128.389 123 119 123C109.611 123 102 130.611 102 140C102 149.389 109.611 157 119 157Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgf)",
    fill: "#E62048"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 147.792H136V160.542H102zM102 119.458H136V132.208H102z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 49C60.3888 49 68 41.3888 68 32C68 22.6112 60.3888 15 51 15C41.6112 15 34 22.6112 34 32C34 41.3888 41.6112 49 51 49Z",
    fill: "#03803D"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgg",
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 15,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 49C60.3888 49 68 41.3888 68 32C68 22.6112 60.3888 15 51 15C41.6112 15 34 22.6112 34 32C34 41.3888 41.6112 49 51 49Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.625 15H57.375V49H44.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E62048",
    d: "M57.375 15H70.125V49H57.375z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 49C128.389 49 136 41.3888 136 32C136 22.6112 128.389 15 119 15C109.611 15 102 22.6112 102 32C102 41.3888 109.611 49 119 49Z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgh",
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 15,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 49C128.389 49 136 41.3888 136 32C136 22.6112 128.389 15 119 15C109.611 15 102 22.6112 102 32C102 41.3888 109.611 49 119 49Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#step2_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step2_svgh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.375 15H129.625V49H108.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.854 29.1667L113.333 29.875L114.042 28.4583L116.167 30.9375L116.521 30.2292L115.812 25.9792L117.229 26.3333L119 23.5L120.771 26.3333L122.188 25.9792L121.479 30.2292L121.833 30.9375L123.958 28.4583L124.312 29.875L127.146 29.1667L126.083 32.3542L127.5 32.7083L123.25 36.25V37.6667L119.354 37.3125V41.9167H118.646V37.3125L114.75 37.6667V36.25L110.5 32.7083L111.917 32.3542L110.854 29.1667Z",
    fill: "#E62048"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.992 128.678L123.984 128.678V128.122C123.984 125.92 122.169 124.135 119.931 124.135C117.692 124.135 115.877 125.92 115.877 128.122V123.736C115.877 121.534 114.063 119.748 111.824 119.748C109.586 119.748 107.771 121.534 107.771 123.736V119.748C107.771 117.546 105.821 115.761 103.583 115.761C101.344 115.761 99.4039 117.679 99.4039 119.881L99.3941 106.988C99.3941 104.785 97.5794 103 95.3409 103C93.1024 103 91.2876 104.785 91.2876 106.988V132.841C91.2876 132.841 87.1408 120.59 81.3065 123.509C79.2669 124.529 78.4138 126.951 79.4277 128.969L86.9698 143.985C86.9698 143.985 91.6316 153 99.7616 153H110.57C118.032 153 124 147.049 124 139.708L123.992 128.678Z",
    fill: "#fff"
  })));
}

export default SvgStep2;